function pluralize(
  count: number,
  labelConfig: string | { singular: string; plural: string }
): string;
function pluralize(count: number, singular: string, plural: string): string;
function pluralize(
  count: number,
  labelConfigOrSingular: string | { singular: string; plural: string },
  plural?: string
): string {
  let singularForm: string;
  if (typeof labelConfigOrSingular === 'object') {
    singularForm = labelConfigOrSingular.singular;
  } else {
    singularForm = labelConfigOrSingular;
  }

  let pluralForm: string;
  if (plural) {
    pluralForm = plural;
  } else if (typeof labelConfigOrSingular === 'object') {
    pluralForm = labelConfigOrSingular.plural;
  } else {
    pluralForm = singularForm.endsWith('s')
      ? `${singularForm}es`
      : `${singularForm}s`;
  }

  if (count === 1) {
    return `${count} ${singularForm}`;
  } else {
    return `${count} ${pluralForm}`;
  }
}

export default pluralize;
